import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';

const CertificatePage = ({ user, onLogout }) => {
  const [certificate, setCertificate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCertificate();
  }, []);

  const fetchCertificate = async () => {
    try {
      const response = await api.get(`/certificates/${user.id}`);
      setCertificate(response.data);
    } catch (err) {
      console.error('Error fetching certificate:', err);
      setError('Certificate not available yet. Complete all modules to earn your certificate.');
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="dashboard" data-testid="certificate-page">
      <div className="dashboard-header">
        <h1>Your Certificate</h1>
        <div className="user-info">
          <Link to="/dashboard" className="btn btn-secondary" data-testid="back-to-dashboard-btn">Back to Dashboard</Link>
          <button onClick={onLogout} className="btn-logout" data-testid="logout-btn">Logout</button>
        </div>
      </div>
      
      <div className="dashboard-content">
        {error ? (
          <div className="modules-section">
            <div className="stat-card" style={{ background: '#fef2f2', borderLeft: '4px solid #dc2626' }}>
              <p style={{ color: '#dc2626' }}>{error}</p>
            </div>
          </div>
        ) : certificate ? (
          <div className="certificate-container">
            <div className="certificate" data-testid="certificate">
              <div className="certificate-header">
                <div className="certificate-title">CERTIFICATE OF COMPLETION</div>
                <div className="certificate-subtitle">Certified Medical Assistant Training Program</div>
              </div>
              
              <div className="certificate-body">
                <p className="certificate-text">This certifies that</p>
                <div className="student-name" data-testid="student-name">{certificate.student_name}</div>
                <p className="certificate-text">
                  has successfully completed all 22 modules of the Certified Medical Assistant (CMA) 
                  Training Program at MedCare Nursing Institute & Training Academy
                </p>
                <p className="certificate-text">
                  Registered through U.S. Dept of Labor Workforce Development Apprenticeship Program
                </p>
              </div>
              
              <div className="certificate-details">
                <div className="detail-item">
                  <div className="detail-label">Certificate Number</div>
                  <div className="detail-value" data-testid="certificate-number">{certificate.certificate_number}</div>
                </div>
                <div className="detail-item">
                  <div className="detail-label">Issue Date</div>
                  <div className="detail-value">{new Date(certificate.issue_date).toLocaleDateString()}</div>
                </div>
                <div className="detail-item">
                  <div className="detail-label">Location</div>
                  <div className="detail-value">Memphis, TN</div>
                </div>
              </div>
            </div>
            
            <div style={{ textAlign: 'center', marginTop: '30px' }}>
              <button onClick={handlePrint} className="btn btn-primary" data-testid="print-certificate-btn">
                Print Certificate
              </button>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default CertificatePage;
